import { schemes, zSchema } from "@zeal/common";

export const updateComplianceFormRequestSchema = zSchema.object({
  companyID: schemes.uuid(),
  formId: zSchema.string(),
  name: zSchema.string(),
  title: zSchema.string(),
});

export type TUpdateComplianceFormRequestSchema = zSchema.infer<
  typeof updateComplianceFormRequestSchema
>;

export const updateComplianceFormResponseSchema = zSchema.any().nullable();

export type TUpdateComplianceFormResponseSchema = zSchema.infer<
  typeof updateComplianceFormResponseSchema
>;
